<template>
<b-row>
  <b-col>
    <b-card>
      <div class="mb-1">
        <i class="ml-2 fa fa-scroll fa-lg"></i><span class="h6 ml-2">{{ $t('views.notice.index') }}</span>
      </div>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && notices.length < 1">
        {{ $t('views.notice.list.noNotices') }}
      </div>
      <table class="table table-sm table-hover table-striped" v-else>
        <tr>
          <th>
            {{ $t('views.notice.list.description') }}
          </th>
          <th></th>
        </tr>
        <tbody>
        <tr v-for="item in notices" :key="item['@id']">
          <td>{{ item.description }}</td>
          <td> <button type="button" class="btn btn-link fa fa-search fa-lg"></button> </td>
        </tr>
        </tbody>
      </table>
    </b-card>
  </b-col>
</b-row>
</template>

<script>
import Loader from '@/components/Dashboard/Layout/Loader'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ClientNotice',
  components: {
    Loader
  },
  computed: {
    ...mapGetters({
      notices: 'clientAgreements/getNotices',
      isLoading: 'clientAgreements/getIsLoadingNotices',
      view: 'clientAgreements/getOrdersView'
    })
  },
  created () {
    this.fetchNotices()
  },
  methods: {
    ...mapActions({
      fetchNotices: 'clientAgreements/fetchNotices'
    })
  }
}
</script>

<style scoped>

</style>
